// Страницы входа: показать пароль и запустить проход камеры.
//
// Отдельный пак, а не часть application: этот код нужен трём страницам
// аутентификации и бесполезен на остальных, а страницы входа должны грузиться
// быстро — человек ещё не в системе и ждать не обязан.

const peek = document.getElementById("auth-peek");
const password = document.getElementById("auth-password");

// Пароль выдаёт администратор, и человек переписывает его с листка. Без
// возможности посмотреть введённое опечатка неотличима от неверного пароля.
if (peek && password) {
    peek.addEventListener("click", () => {
        const hidden = password.type === "password";
        password.type = hidden ? "text" : "password";
        peek.textContent = hidden ? "Скрыть" : "Показать";
        peek.setAttribute("aria-label", hidden ? "Скрыть пароль" : "Показать пароль");
        password.focus();
    });
}

// Ролик — съёмка в ангаре, смонтированная из нескольких планов. Стык цикла
// такой же склейкой и выглядит: маскировать его не нужно, он не выбивается из
// остальных.
//
// Пока файл не догружен целиком, на экране кадр-подложка: старт по
// canplaythrough, иначе цикл упирается в недокачанный хвост и встаёт на
// середине. Если ролик не доехал вовсе, подложка так и остаётся — пустой
// правая половина не будет никогда.
const video = document.getElementById("auth-flyby");
const slow = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

if (video && !slow) {
    let live = false;

    const start = () => {
        if (live) return;
        live = true;
        video.classList.add("auth-video--on");
        const played = video.play();
        if (played && played.catch) played.catch(() => video.classList.remove("auth-video--on"));
    };

    video.addEventListener("canplaythrough", start);
    // Буферизация: прячем видео под подложку, а не показываем замерший кадр.
    video.addEventListener("waiting", () => video.classList.remove("auth-video--on"));
    video.addEventListener("playing", () => { if (live) video.classList.add("auth-video--on"); });

    // canplaythrough может не прийти вовсе — на медленном канале браузер
    // притормаживает загрузку. Данных для проигрывания уже достаточно — стартуем.
    setTimeout(() => { if (!live && video.readyState >= 3) start(); }, 2500);

    document.addEventListener("visibilitychange", () => {
        if (!live) return;
        if (document.hidden) video.pause();
        else video.play().catch(() => {});
    });
}
